import React from 'react';
import IntlMessages from '../../../utils/IntlMessages';
import { ArrowForward } from '@material-ui/icons';
import { ADMIN_TYPES, DEALER_TYPES, MANAGER_TYPES } from 'constants/Systems';

const summaryReportMenus = {
  name: <IntlMessages id={'summary-report'} />,
  type: 'collapse',
  children: [
    {
      name: <IntlMessages id={'summary-report.overview'} />,
      icon: <ArrowForward />,
      type: 'item',
      link: '/app/summary-report/overview',
    },
    {
      name: <IntlMessages id={'summary-report.factor'} />,
      icon: <ArrowForward />,
      type: 'item',
      link: '/app/summary-report/factor',
    },
    {
      name: <IntlMessages id={'summary-report.car-model'} />,
      icon: <ArrowForward />,
      type: 'item',
      link: '/app/summary-report/car-model',
    },
  ],
};

const relationMenus = {
  name: <IntlMessages id={'relation'} />,
  type: 'collapse',
  children: [
    {
      name: <IntlMessages id={'relation.dealer'} />,
      icon: <ArrowForward />,
      type: 'item',
      link: '/app/relation/dealer',
    },
    {
      name: <IntlMessages id={'relation.customer'} />,
      icon: <ArrowForward />,
      type: 'item',
      link: '/app/relation/customer',
    },
  ],
};

const powerBiMenus = {
  name: <IntlMessages id={'powerbi'} />,
  type: 'item',
  link: '/app/powerbi',
};

const redAlertMenus = {
  name: <IntlMessages id={'redalert'} />,
  type: 'item',
  link: '/app/redalert',
};

const rankingMenus = {
  name: <IntlMessages id={'ranking'} />,
  type: 'item',
  link: '/app/ranking',
};

const customerVoiceMenus = {
  name: <IntlMessages id={'customer-voice'} />,
  type: 'item',
  link: '/app/customer-voice',
};

const downloadMenus = {
  name: <IntlMessages id={'download'} />,
  type: 'collapse',
  children: [
    {
      name: <IntlMessages id={'download.customer-list'} />,
      icon: <ArrowForward />,
      type: 'item',
      link: '/app/download/customer-list',
    },
    {
      name: <IntlMessages id={'download.topline'} />,
      icon: <ArrowForward />,
      type: 'item',
      link: '/app/download/topline',
    },
    {
      name: <IntlMessages id={'download.topline-pdf'} />,
      icon: <ArrowForward />,
      type: 'item',
      link: '/app/download/topline-pdf',
    },
    {
      name: <IntlMessages id={'download.interview'} />,
      icon: <ArrowForward />,
      type: 'item',
      link: '/app/download/interview',
    },
    {
      name: <IntlMessages id={'download.dropoff'} />,
      icon: <ArrowForward />,
      type: 'item',
      link: '/app/download/dropoff',
    },
    {
      name: <IntlMessages id={'download.topline-pivot'} />,
      icon: <ArrowForward />,
      type: 'item',
      link: '/app/download/topline-pivot',
    },
  ],
};

const downloadDealerMenus = {
  name: <IntlMessages id={'download'} />,
  type: 'collapse',
  children: [
    {
      name: <IntlMessages id={'download.customer-list'} />,
      icon: <ArrowForward />,
      type: 'item',
      link: '/app/download/customer-list',
    },
    {
      name: <IntlMessages id={'download.topline'} />,
      icon: <ArrowForward />,
      type: 'item',
      link: '/app/download/topline',
    },
    {
      name: <IntlMessages id={'download.topline-pdf'} />,
      icon: <ArrowForward />,
      type: 'item',
      link: '/app/download/topline-pdf',
    },
    {
      name: <IntlMessages id={'download.interview'} />,
      icon: <ArrowForward />,
      type: 'item',
      link: '/app/download/interview',
    },
  ],
};

const filterMenus = {
  name: <IntlMessages id={'filter'} />,
  type: 'item',
  link: '/app/filter',
};

const settingMenus = {
  name: <IntlMessages id={'setting'} />,
  type: 'collapse',
  children: [
    {
      name: <IntlMessages id={'user'} />,
      icon: <ArrowForward />,
      type: 'item',
      link: '/app/user',
    },
    {
      name: <IntlMessages id={'dealer'} />,
      icon: <ArrowForward />,
      type: 'item',
      link: '/app/dealer',
    },
    {
      name: <IntlMessages id={'import'} />,
      icon: <ArrowForward />,
      type: 'item',
      link: '/app/import',
    },
  ],
};

const catiAdminMenus = {
  name: <IntlMessages id={'catiadmin'} />,
  type: 'collapse',
  children: [
    {
      name: <IntlMessages id={'catiadmin.fw-progress'} />,
      icon: <ArrowForward />,
      type: 'item',
      link: '/app/catiadmin/fw-progress',
    },
    {
      name: <IntlMessages id={'catiadmin.export-raw-data'} />,
      icon: <ArrowForward />,
      type: 'item',
      link: '/app/catiadmin/export-raw-data',
    },
    // {
    //   name: <IntlMessages id={'catiadmin.qc-data'} />,
    //   icon: <ArrowForward />,
    //   type: 'item',
    //   link: '/app/catiadmin/qc-data',
    // },
  ],
};

export const sidebarNavs = authUser => {
  return [
    {
      name: <IntlMessages id={'main'} />,
      type: 'section',
      children: generateMenus(authUser),
    },
  ];
};

export const horizontalDefaultNavs = authUser => {
  return [
    {
      name: <IntlMessages id={'sidebar.main'} />,
      type: 'collapse',
      children: generateMenus(authUser),
    },
  ];
};

export const minimalHorizontalMenus = authUser => {
  return [
    {
      name: <IntlMessages id={'sidebar.main'} />,
      type: 'collapse',
      children: generateMenus(authUser),
    },
  ];
};

export const generateMenus = authUser => {
  let menus = [];
  if (authUser) {
    if (ADMIN_TYPES.includes(authUser.type)) {
      menus = [
        summaryReportMenus,
        // relationMenus,
        // powerBiMenus,
        redAlertMenus,
        rankingMenus,
        customerVoiceMenus,
        downloadMenus,
        // filterMenus,
        settingMenus,
        catiAdminMenus,
      ];
      // menus = [redAlertMenus, downloadMenus, settingMenus, catiAdminMenus,];
    } else if (MANAGER_TYPES.includes(authUser.type)) {
      menus = [
        summaryReportMenus,
        // relationMenus,
        // powerBiMenus,
        redAlertMenus,
        rankingMenus,
        customerVoiceMenus,
        downloadMenus,
        // filterMenus,
        // settingMenus,
        // catiAdminMenus,
      ];
    } else if (DEALER_TYPES.includes(authUser.type)) {
      menus = [
        summaryReportMenus,
        // relationMenus,
        redAlertMenus,
        rankingMenus,
        customerVoiceMenus,
        downloadDealerMenus,
        // filterMenus,
        // settingMenus,
        // catiAdminMenus,
      ];
      // menus = [redAlertMenus, downloadDealerMenus];
    }
  }
  return menus;
};
